// Shared pieces for card-based screens, first used on My Dashboard: the link in
// a card header, the heading that groups several cards, and the footer under a
// list that shows only some of its rows. Reuse them so screens read alike.

// Shared look for the small link in a card header ("View all", "Open My Time").
export const HEADER_LINK = 'text-[11px] font-semibold text-gold hover:underline';

// A heading that groups several cards ("My Space"), set apart from the card
// titles inside it.
export const SECTION_HEADING = "flex items-center gap-3 text-sm font-bold text-navy mb-2 after:content-[''] after:flex-1 after:h-px after:bg-gray-200";

// The line under a list that shows only some of its rows: what is shown, then
// where the rest are. One pattern for every card on the page.
export function CardFooter({ children, link, onClick, className = '' }) {
  return (
    <div className={`px-3 py-1.5 border-t border-gray-100 flex items-center justify-between gap-3 text-[11px] ${className}`}>
      <span className="text-gray-500">{children}</span>
      {link && <button type="button" onClick={onClick} className={HEADER_LINK}>{link}</button>}
    </div>
  );
}
